import { signal } from "@preact/signals-react";

const pulseDurationMS = 650;

export const activityPulseActive = signal(false);

let activityPulseTimer: number | null = null;

export function markActivityPulse() {
    activityPulseActive.value = true;

    if (activityPulseTimer !== null) {
        window.clearTimeout(activityPulseTimer);
    }

    activityPulseTimer = window.setTimeout(() => {
        activityPulseTimer = null;
        activityPulseActive.value = false;
    }, pulseDurationMS);
}
